'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);
var functions = require('./functions.js');
var magicSdk = require('@gig/magic-sdk');

const SessionChange = ({ immediate } = {}) => Component.createDecorator((options, key) => {
  if (!options.methods) {
    options.methods = {};
  }
  const functionToCall = options.methods[key];
  if (functionToCall && typeof functionToCall === "function") {
    const subscriptions = [];
    options.created = functions.hookFunction(options.created, function() {
      const handler = (isLoggedIn) => {
        functionToCall.call(this, isLoggedIn);
      };
      if (immediate) {
        handler(!!magicSdk.magic.session.getUser());
      }
      subscriptions.push(magicSdk.magic.events.sessionCreated(() => handler(true)).unsub);
      subscriptions.push(magicSdk.magic.events.sessionDestroyed(() => handler(false)).unsub);
    });
    options.beforeDestroy = functions.hookFunction(options.beforeDestroy, function() {
      subscriptions.forEach((unsub) => {
        unsub();
      });
    });
  }
});

exports.SessionChange = SessionChange;
